import ToggleButton from 'react-toggle-button';
import useToggleActive from './hooks/useToggleActive';
import './styles.scss';

const ToggleActive = ({ document, setToRefresh }) => {
  const { active, handleActive } = useToggleActive(document, setToRefresh);

  return (
    <div key={document?.ID} className="toggle__active">
      <label>Ativo:</label>
      <ToggleButton value={active} onToggle={handleActive} />
    </div>
  );
};

export default ToggleActive;
